import React, { useState } from 'react';
import axios from 'axios';
import '../../App.css';
import './ForgotPassword.css';
import Logo from '../../shared/components/common/Logo';
import { API_ENDPOINTS } from '../../config/apiConfig';
import { APP_NAME } from '../../config/appConstants';
import AuthPageFooter from '../../shared/components/common/AuthPageFooter';
import appLogo from '../../assets/images/DevicePulse-app-logo2.png';

function ForgotPassword() {
  const [identifier, setIdentifier] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    // Client-side validation
    if (!identifier || identifier.trim() === '') {
      setError('Please enter your email or username');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, {
        identifier: identifier.trim()
      });
      
      setMessage('If the email or username exists, a password reset link has been sent to your registered email address.');
      setIdentifier('');
    } catch (err) {
      console.error('Error:', err);
      setError(err.response?.data?.error || err.response?.data?.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      {/* Left Side - Branding */}
      <div className="forgot-password-left-side">
        <div className="particles"></div>
        <div className="medical-pattern"></div>
        
        {/* Floating Medical Icons */}
        <div className="medical-float-1">🏥</div>
        <div className="medical-float-2">💊</div>
        <div className="medical-float-3">🩺</div>
        <div className="medical-float-4">⚕️</div>
        <div className="medical-float-5">🔬</div>
        <div className="medical-float-6">💉</div>

        {/* Left Side Content */}
        <div className="left-side-content">
          <div className="left-side-text">
            <h1>
              <img src={appLogo} className="emoji-app-logo" alt="App Logo" />
              {APP_NAME}
            </h1>
            <p>Secure access to your device management system</p>
          </div>
        </div>
      </div>

      {/* Right Side - Reset Form */}
      <div className="forgot-password-right-side">
        <AuthPageFooter />

        <div className="forgot-password-box">
          <div className="reset-header">
            <h3>Reset Password</h3>
            <p>Enter your email or username to receive a reset link</p>
          </div>

          <form className="reset-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="identifier">Email or Username</label>
              <input
                type="text"
                id="identifier"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                placeholder="Enter your email or username"
                required
                disabled={loading}
              />
            </div>

            {error && <div className="error-message">{error}</div>}
            {message && (
              <div className="info-message">
                <div className="info-icon">ℹ️</div>
                <div className="info-content">
                  <div className="info-title">Check Your Email</div>
                  <div className="info-text">{message}</div>
                </div>
              </div>
            )}

            <button
              type="submit"
              className="action-btn action-primary action-btn-block"
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <div className="back-to-login-section">
              <a href="/login" className="back-to-login-link">← Back to Login</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
